const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import {isPresent} from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT} from "../../constants";
import render from "../../utilities/render";
import {statusPillRender,buildExport,prepareDataToSendController,isEdit,doAjax,pushFilterSessionCacheState,retriveCriteriaObjectByOperation,isNew,isDeleteView,isOnlyLookupDataUpdate} from "../../utilities/filtersutil";
import {asnLookupFieldDropdown} from "./filter/lookupFieldDropdown.js";
import {actionOptions} from "./filter/actionOptions.js";
const _ = require("underscore");
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";
const detailLinkHTML = require('../../utilities/filtersutil/html/detailLinkHTML.html');



let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');


const targetSelector = "#asn-lookup-outer";
run(targetSelector, ()=>{
	const dataTableComponentData = $(targetSelector).data("asn-lookup-data");
  let submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  const savedViews = $(targetSelector).data("saved-views");
  const asnPortletEditPerm = $(targetSelector).data("asn-portlet-edit-perm");
  const viewAsnRenderUrl = $(targetSelector).data("asn-detail-url");
  const portletNamespace =  $(targetSelector).data("portlet-namespace");
  const filterURL =  $(targetSelector).data("filter-url");
  const saveViewURL  =  $(targetSelector).data("save-view-url");
  const deleteViewURL  =  $(targetSelector).data("delete-view-url");
  let targetObject = "";
  let selectedRows = "";
  let exportModal = new buildExport();
  const exportUrl = $(targetSelector).data("export-url");
  const editASNUrl = $(targetSelector).data("edit-asn-url");
  const cancelASNUrl = $(targetSelector).data("cancel-asn-url");
  const bulkCancelASNUrl = $(targetSelector).data("bulk-cancel-asn-url");
  const shouldCheckCache  =  $(targetSelector).data("should-check-cache");
  const criteriaObjectFromServer  =  $(targetSelector).data("filter-criteria-from-server");
  if(shouldCheckCache)
  {
    targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer,"like");
  }

  let asnLookup = new LookupTable({

    target: $("#asn-lookup-wrapper"),

    minWidthClass: "q-min-width-sm-til-md",

    mobileColumns: [
        {
          data: "asnShipmentId",
          title: "Shipment ID",
          render: createDetailLink
        },
        {
          data: "asnType",
          title: "Shipment Type"
        },
        {
          data: "asnStatus",
          title: "Shipment Status"
        },
        {
          data: "destination",
          title: "Destination"
        }
    ],

    // REQUIRED: search input info
    tableSearchInput: {
      value: (targetObject != "" ? targetObject.value[0] : "")
    },
    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    tableSearchDropdown: {
      selected: (targetObject == "" ? "" : targetObject.key),
      columns:asnLookupFieldDropdown
    },
    // OPTIONAL: Set Saved View Array
    savedViews: savedViews,
    bulkSelect: true,

    dataTable: {
      // use same settings you would if you were just calling a dataTable normally
      data: dataTableComponentData.content,
      // Not required, just to show you can
      columnDefs: [
         { className: "custom-class", targets: [ 1 ] }
      ],
      // Not required, just to show you can
      order: [
        [6, 'desc']
      ],
      columns: [
        {
          data: "asnStatus",
          render : renderActionWrap,
          orderable:false,
          class: "dtc-action-column"
        },
        {
          data: "asnShipmentId",
          title: "Shipment ID",
          render: createDetailLink,
          class: "dtc-min-width-sm"
        },
        {
          data: "skuCount",
          title: "Total SKUs/Units",
          class: "dtc-min-width-sm",
          orderable:false
        },
        {
          data: "asnType",
          title: "Shipment Type",
          render: renderAsnType,
          class: "dtc-min-width-md"
        },
        {
          data: "asnStatus",
          title: "Shipment Status",
          class: 'dtc-min-width-sm',
          render:statusPillRender
        },
        {
          data: "asnCreatedDate",
          title: "Date Created",
          render: formateDate,
          class: "dtc-min-width-md"
        },
        {
          data: "destination",
          title: "Destination",
          class: "dtc-min-width-sm",
          orderable:false
        }
      ]
    },

    paginationData:dataTableComponentData.page,

    filterModal: {
        title: "Filter Shipments",
        tableType: "asn"
    },

    onBulkSelectChange: function() {
      selectedRows = asnLookup.getBulkSelectedData();
      $("th.dtc-action-column").html(renderActionHeaderWrap());
      if (selectedRows.length >= 2) {
        $(".action-header-btn .base-btn").removeClass('disabled');
      } else {
        $(".action-header-btn .base-btn").addClass('disabled');
      }
    },

    onFetch:function() {
      let currentData = asnLookup.generateData();
      asnLookup.showLoadingOverlay();
      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
      if(isOnlyLookupDataUpdate(currentData)){
        setTimeout(() => {
          doAjax({url: filterURL, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData,portletNamespace)});
        },SUCCESS_MODAL_TIMEOUT);
      }else if(isNew(currentData)){
        setTimeout(() => {
          doAjax({url: saveViewURL, success: savedViewSuccess, error: errorFun, data:prepareDataToSendController(currentData,portletNamespace)});
        },SUCCESS_MODAL_TIMEOUT);
       }else if(isEdit(currentData)){
        setTimeout(() => {
          doAjax({url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data:prepareDataToSendController(currentData,portletNamespace)});
        },SUCCESS_MODAL_TIMEOUT);
       }else if(isDeleteView(currentData)){
         setTimeout(() => {
          doAjax({url: deleteViewURL, success: delteViewScussFun, error: errorFun, data:prepareDataToSendController(currentData,portletNamespace)});
         },SUCCESS_MODAL_TIMEOUT);
       }
    }
  });

  function filterSuccessFun(data){

      let asn = data.content;
      let page = data.page;
      asnLookup.setNewData(asn);
      asnLookup.setPaginationData(page);
      pushFilterSessionCacheState();
      asnLookup.hideLoadingOverlay();
      setExportData(asnLookup.generateData());
    }

    function savedViewSuccess(data){
        let asn = data.lookupASNJSON.content;
        let page = data.lookupASNJSON.page;
        asnLookup.setNewData(asn);
        asnLookup.setPaginationData(page);
        asnLookup.setNewSavedViewData(data.savedView, "newSavedView");
        pushFilterSessionCacheState();
        asnLookup.hideLoadingOverlay();
        setExportData(asnLookup.generateData());
    }


    function savedEditViewSuccess(data){
        let asn = data.lookupASNJSON.content;
        let page = data.lookupASNJSON.page;
        asnLookup.setNewData(asn);
        asnLookup.setPaginationData(page);
        asnLookup.setNewSavedViewData(data.savedView, data.savedView.target);
        pushFilterSessionCacheState();
        asnLookup.hideLoadingOverlay();
        setExportData(asnLookup.generateData());
    }


    function delteViewScussFun(data){
      let asn = data.lookupASNJSON.content;
      let page = data.lookupASNJSON.page;
      asnLookup.removeSavedView(data.target);
      asnLookup.setNewData(asn);
      asnLookup.setPaginationData(page);
      asnLookup.hideLoadingOverlay();
      setExportData(asnLookup.generateData());
    }

    function errorFun(data){
          asnLookup.hideLoadingOverlay();
    }

  asnLookup.init();

  function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = actionOptions["actions"];
    newRender = render(
      actionCellDropdownTemplate, {
        list: renderActionCellList(statusTarget, data, row),
        index: meta.row
      }
    );
    return newRender;
  }

  function renderActionHeaderWrap() {
    let statusTarget = actionOptions['all'];
    let newRender;
    let data = "";
    let row = "";
    newRender = render(
      actionHeaderDropdownTemplate, {
        list: renderActionCellList(statusTarget, data, row)
      }
    );
    return newRender;
  }

  function renderActionCellList(list,data,row) {
    let renderedList;
    renderedList = _(list).map((item)=>{
      return render(
        actionCellDropdownItemTemplate, {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled:checkDisableForGivenAction(data, row, item.title)
        }
      );
    });
    return renderedList.join('');
  }

  function checkDisableForGivenAction(data,row,actionName) {
    if(isRowLevelActionCheck(data)){
      return callBusinessLogicToDisableAction(data,row,actionName);
    } else {
      let isTrue = false;
      _(selectedRows).map((item)=>{
        if(callBusinessLogicToDisableAction(item.data.asnStatus, item.data, actionName)) {
          if (!isTrue){
            isTrue = true;
          }
        }
      });
      return isTrue;
    }
  }

  function isRowLevelActionCheck(data) {
    return isPresent(data);
  }

  function callBusinessLogicToDisableAction(data, row, actionName) {    
      if(row.asnType === "T"){//No edit for warehouse transfer
        return true;
      }else if(row.asnType === "R"){
        if(actionName == "Edit") {
          return true;
        }else if (data==="Canceled" || data==="Complete" || data==="Receiving") {
          return true;
        } else if(actionName == "Cancel"){
          return false;
        }
      }else{
        if(asnPortletEditPerm === false) {
          return true;
        } else if(data==="Planned" || data==="In Transit") {   
          if(data==="In Transit" && actionName == "Edit"){            
            return true;
          }else if(row.canEditGtlAsn){           
            return false;
          } else if(actionName == "Cancel"){            
            return true;
          }
        } else {
          return true;
        }
      }
  }

  function formateDate(createdDate, type, data){
    if(createdDate != null && createdDate != "") {
      let date = new Date(createdDate); //createdDate is long time format
      let month = date.getMonth() + 1;
      let today = new Date();
      let oneDay = 24*60*60*1000;
      today.setHours(0,0,0,0);
      date.setHours(0,0,0,0);
      let diffDays = Math.round(Math.abs((today.getTime() - date.getTime())/(oneDay)));
      let friendlyText = "";
      let datePillHTML  = "" ;
      if(diffDays < 100) {
        friendlyText = diffDays.toString() + ' Days Ago';
        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>";
      }
      if(diffDays == 0) {
        friendlyText = 'Today';
      } else if(diffDays== 1) {
        friendlyText ='Yesterday';
      }
      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
    } else {
      return "";
    }
  }



  function createDetailLink(data, type, row) {
    let detailPageHTML = render(
      detailLinkHTML, {
          renderURL :  viewAsnRenderUrl,
          portletNamespace :  portletNamespace,
          id :   row.asnId,
          idName : "asnId",
          displayVal:row.asnShipmentId
      }
    );
    return detailPageHTML;
  }


  function renderAsnType(data, type, row) {
    if(row.asnType === "R") {
      return "Return";
    } else if(row.asnType === "P") {
      return "Inbound";
    } else if(row.asnType === "T") {
      return "Transfer";
    } else {
      return "";
    }
  }

  function initExport() {
    let exportObj  =  {
      title : $(targetSelector).data("export-popup-title"),
      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
    };
    exportModal.init(exportObj);
    exportModal.bindExportEvent(portletNamespace);
  }

  function setExportData(currentData) {
    exportModal.buildExportBasicURL(exportUrl,currentData,portletNamespace);
    exportModal.setExportCount(currentData.totalElements);
  }

  $('body').on('click', '.edit-asn', function(e) {
    e.preventDefault();
    if(shallAllowClick(this)) {
      let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
      let parent = $(".dropdown-parent-" + pIndex).parents('tr');
      let row = $(".data-table-component").dataTable().api().row(parent);
      let asn = row.data();
      location.href = `${editASNUrl}&${portletNamespace}asnId=${asn.asnId}`;
    }
  });


  $('body').on('click', '.cancel-asn ', function(e) {
    e.preventDefault();
    if(shallAllowClick(this)) {
      let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
      let parent = $(".dropdown-parent-" + pIndex).parents('tr');
      let row = $(".data-table-component").dataTable().api().row(parent);
      $("#cancelModal").appendTo("body").data('row', row).modal("show");
    }
  });


  $('#modalCancelAsn').click(function(){
    let row = $('#cancelModal').data('row');
    submitModalFlow.showLoadingModal();
    cancelAsn(row, row.data());
  });

  function cancelAsn(row, asn){
      $.ajax({
      url: cancelASNUrl,
      type: 'POST',
      data: {
        [`${portletNamespace}asnId`]: asn.asnId
      },
      success: function(data){
        if(data.match("success")) {
          let d = row.data();
          d.asnStatus = "Canceled";
          row.data(d).draw();
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            submitModalFlow.hideAllModals();
            }, SUCCESS_MODAL_TIMEOUT);
        }
      },
      error:function(data){
        submitModalFlow.hideAllModals();
      }
    });
  }


  function shallAllowClick(currentObj){
   return  !($(currentObj).hasClass("disabled"));
  }

  $('body').on('click', '.bulk-cancel-asn', function(e) {
    e.preventDefault();
    if(shallAllowClick(this)){
      $("#bulkCancelModal").modal("show");
    }
  });

  $('#modalBulkCancelAsn').click(function(){
    submitModalFlow.showLoadingModal();
    bulkCancelASN();
  });


  function bulkCancelASN(row, asn){
      $.ajax({
      url: bulkCancelASNUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        [`${portletNamespace}asnId`]: getAllSelectedAsnIds()
      },
      success: function(data){
        if(data.response === "success") {
          _(selectedRows).map((item)=>{
            let currentRow =  $(".data-table-component").dataTable().api().row(item.rowIndex);
            let d = currentRow.data();
            d.asnStatus = "Canceled";
            currentRow.data(d).draw();
          });
          setTimeout(function() {
           submitModalFlow.hideAllModals();
          },  SUCCESS_MODAL_TIMEOUT);

        }
      },
      error:function(data){
        submitModalFlow.hideAllModals();
      }
    });
  }


  function getAllSelectedAsnIds(){
    let asnIds = new Array();
    _(selectedRows).map((item)=>{
      asnIds.push(item.data.asnId);
     });
    return JSON.stringify(asnIds);
  }


  initExport();
  setExportData(asnLookup.generateData());


    handleCustomDropdownEvents();

    $("th.dtc-action-column").html(renderActionHeaderWrap());

});



// WEBPACK FOOTER //
// ./src/pages/asns/lookup.js